import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOhInvestigation } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";
/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const OnHandInvestigationAPI = async (
  params: IOhInvestigation,
  osdNumber: number,
  action: string
) => {
  try {
    const url = `${getUrl(ApiType.ON_HAND_INVESTIGATION).replace(
      ":osdNumber",
      osdNumber.toString()
    )}/${action}`;
    const response = await axios.post(url, params);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.ohInvestigationError);
  }
};
